export default __webpack_public_path__ + "static/media/bluetopaztoken.01cd46c9.png";